<template>
  <div v-loading="loading">
    <div ref="tablePrint" class="print">
      <div style="margin-top:10px;height:650px;overflow:auto">
        <div id="tablePrint">
          <posDayliReportTable :listQuery="listQuery" :tabelList="tabelList" :sumsTotal="sumsTotal" :headerList='headerList'></posDayliReportTable>
        </div>
      </div>
    </div>
    <div ref="tablePrintExport" class="Export_table" v-show="false">
      <div style="margin-top:10px;height:650px;overflow:auto">
        <div id="tablePrintExport">
          <posDayliReportTable :listQuery="listQuery" :exportShow="true" :sumsTotal="sumsTotal" :tabelList="tabelList" :headerList='headerList'></posDayliReportTable>
        </div>
      </div>
    </div>
    <div id="copy_div" v-show="false" style="'width:100%'" class="'flex-seting'"></div>
  </div>
</template>
<script>
import DateUtils from '@/utils/DateUtils';
  import getLodop from '../../utils/Lodopfuncs'

import posDayliReportTable from './posDayliReportTable'
// import { posDayliReport } from '@/api/reportcenter/ReportTableDefinition'
// import getLodop from '@/utils/LodopFuncs.js'
export default {
  components: { posDayliReportTable },
  data() {
    return {
      listQuery: {
        shiftCode: '',
        userId: '',
        outletId: '',
       startTime:DateUtils.formatDate(new Date(), "yyyy-MM-dd"),
        endTime:DateUtils.formatDate(new Date(), "yyyy-MM-dd"),
        queryLike:''
      },
      employee:localStorage.getItem('user'),
      currentTime: DateUtils.formatDate(new Date(), "yyyy-MM-dd hh:mm"), //当前的时间
      hotelInfo:localStorage.getItem('hotelInfo'),
      loading: false,
      tabelList: [],
      sumsTotal: {
        quantity: 0,
        price: 0,
        discount: 0,
        tax: 0,
        server_price: 0,
        discount_price: 0,
        all_price: 0,
        headerList: []
      }
    }
  },
  created() {
    this.getInit()
    this.$bus.$on('todoQuery', this.getData)
    this.$bus.$on('todoPrintCatering', this.todoPrint)
    this.$bus.$on('todoExportCatering', this.todoExport)
  },
  beforeDestroy() {
    this.$bus.$off('todoQuery', this.getData);
    this.$bus.$off('todoPrintCatering', this.todoPrint)
    this.$bus.$off('todoExportCatering', this.todoExport)
  },
  methods: {
    getData(val) {
      this.listQuery = Object.assign({}, val)
      this.getInit()
    },
    getInit() {
    
        var methods = "get"
        let url = this.api.posDayliReport
        let data = this.listQuery
        this.$axios({
          url,
          methods,
          data
        }).then(res => {
        if (res.data.status == 0) {
          let arr = []

          res.data.data.map(e => {
            e['合计'] = 0
            Object.keys(e).forEach(key => {
              if (key !== 'productName' && key !== '合计') {

                e['合计'] += e[key] * 1
             
              
              }
            })
          })
          Object.keys(res.data.data[0]).forEach(key => {
            if (key !== 'productName') {
              console.log(key);
              arr.push(key)

            }
          })

          this.headerList = arr
          this.tabelList = res.data.data

        }
      })
    },
    todoPrint(type) {
      const LODOP = getLodop()
      // 获取大小和宽度
      let printSize =12
      let width = 2
      if (LODOP) {
        // 判断是否是数字
        let falg = false
        if (document.getElementById('tablePrint')) {
          document.getElementById("copy_div").innerHTML = ""
          let innerHTML = document.getElementById('tablePrint').cloneNode(true)
          innerHTML.style.border = 'none'
          innerHTML.style.borderCollapse = 'collapse'
          innerHTML.style.fontSize = printSize + 'px'
          document.getElementById("copy_div").appendChild(innerHTML);
          falg = true
        }
        this.$nextTick(() => {
          var strFormHtml = `
                <body >` +
            document.getElementById(falg ? 'copy_div' : 'tablePrint').innerHTML
            +
            '</body>'   //获取打印内容
          LODOP.PRINT_INIT('')  //初始化
          LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4')  //设置纵向
          LODOP.ADD_PRINT_TABLE('2%', width + '%', (100 - width * 2) + '%', '88%', strFormHtml)
          LODOP.SET_PRINT_STYLEA(0, "Offset2Top", -100)
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", 0)
          LODOP.SET_PREVIEW_WINDOW(2, 0, 0, 800, 600, '')  //设置预览窗口模式和大小
          LODOP.ADD_PRINT_TEXT(566, 542, 165, 22, "第#页/共&页");
          LODOP.SET_PRINT_STYLEA(0, "ItemType", 2);
          LODOP.SET_PRINT_STYLEA(0, "Horient", 2);
          LODOP.SET_PRINT_STYLEA(0, "Vorient", 1);
          if (type === 'preview') {
            LODOP.PREVIEW();
          } else {
            LODOP.PRINT()
          }
        })
      }
    },
    todoExport() {
      const LODOP = getLodop()
      if (LODOP) {
        // 获取大小和宽度
        let width = 2
        var strFormHtml = '<body>' + document.getElementById('tablePrintExport').innerHTML + '</body>'   //获取打印内容
        LODOP.PRINT_INIT('')  //初始化
        LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4')  //设置纵向
        LODOP.ADD_PRINT_TABLE('2%', width + '%', (100 - width * 2) + '%', '88%', strFormHtml)
        LODOP.SET_PRINT_STYLEA(0, "Offset2Top", -100)
        LODOP.SAVE_TO_FILE("餐饮营业日报.xlsx");
      }
    }
  }
}
</script>